<template>
	<div>
		<PersonalBanner />
		<div class="content-zsy">
			<div class="title-wrap">
				<h3>배송대행</h3>
				<h4 style="transition-delay: 0.3s;">중국 직구<br class="visible-xs"> 어떻게 진행되나요?</h4>
				<div class="summary">중국 직구 배송 서비스를 안내해드릴게요.</div>
			</div>
			<el-row>
				<el-col :xs="24" :sm="12" :md="8">
					<div class="type-card">
						<div class="card-head">
							1. 가입 및 구매
							<img loading="lazy" src="../../assets/icon/flag_cn.png" alt="" class="">
						</div>
						<div class="card-body">
							<p class="mb20">
								1.중국쇼핑몰에서 상품을 구매/결제합니다.
							</p>
							<div class="img-box">
								<img loading="lazy" v-if="!isMobile" src="../../assets/list/document_delivery_guide_img1.png" alt="" class="img-responsive" >
								<img loading="lazy" v-else src="../../assets/list/document_delivery_guide_img1.png" alt=""  class="img-responsive" >
							</div>
							<p class="mb20">
								2.중국 내 배송이 시작됩니다.
							</p>
							<div class="img-box">
								<img loading="lazy" v-if="!isMobile" src="../../assets/list/document_delivery_guide_img2_2x.png" alt="" class="img-responsive" >
								<img loading="lazy" v-else src="../../assets/list/document_delivery_guide_img2_2x.png" alt=""  class="img-responsive" >
							</div>
						</div>			
					</div>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8">
					<div class="type-card">
						<div class="card-head">
							2. 검수/포장
							<!-- <img loading="lazy" src="../../assets/icon/ico_packing.png" alt="" class=""> -->
						</div>
						<div class="card-body">
							<p class="mb20">
								1.구매하신 상품이 고로켓고 중국센터에 도착하면 신청하신 내용과 일치하는지 검수합니다.
							</p>
							<div class="img-box">
								<img loading="lazy" v-if="!isMobile" src="../../assets/list/document_delivery_guide_img3_2x.png" alt="" class="img-responsive" >
								<img loading="lazy" v-else src="../../assets/list/document_delivery_guide_img3_2x.png" alt=""  class="img-responsive" >
							</div>
							<p class="mb20">
								2.검수가 완료되면 신청하신 옵션으로 상품을 포장합니다.
							</p>
							<div class="img-box">
								<img loading="lazy" v-if="!isMobile" src="../../assets/list/document_delivery_guide_img4_2x.png" alt="" class="img-responsive" >
								<img loading="lazy" v-else src="../../assets/list/document_delivery_guide_img4_2x.png" alt=""  class="img-responsive" >
							</div>
						</div>			
					</div>
				</el-col>
				<!-- <el-col :xs="24" :sm="12" :md="8">
					<div class="type-card">
						<div class="card-head">
							3. 배송비 결제
							
						</div>
						<div class="card-body">
							<p class="mb20">
								1.포장이 완료된 상태에서 배송무게/크기를 측정하여 배송비 결제요청 알림톡으로 안내드립니다.
							</p>
							<div class="img-box">
								<img loading="lazy" v-if="!isMobile" src="../../assets/list/document_delivery_guide_img5.png" alt="" class="img-responsive" >
								<img loading="lazy" v-else src="../../assets/list/document_delivery_guide_img5_2x.png" alt=""  class="img-responsive" >
							</div>
							<p class="mb20">
								2.안내받으신 배송비를 결제하시면 국제배송을 시작합니다.
							</p>
							<div class="img-box">
								<img loading="lazy" v-if="!isMobile" src="../../assets/list/document_delivery_guide_img6.png" alt="" class="img-responsive" >
								<img loading="lazy" v-else src="../../assets/list/document_delivery_guide_img6_2x.png" alt=""  class="img-responsive" >
							</div>
						</div>			
					</div>
				</el-col> -->
				<el-col :xs="24" :sm="12" :md="8">
					<div class="type-card">
						<div class="card-head">
							3. 운송/통관
							<img loading="lazy" src="../../assets/icon/ico_customs.png" alt="" class="">
						</div>
						<div class="card-body">
							<p class="mb20">
								1.중국세관 수출통관 후 국제운송을 시작합니다.
							</p>
							<div class="img-box">
								<img loading="lazy" v-if="!isMobile" src="../../assets/list/document_delivery_guide_img7_2x.png" alt="" class="img-responsive" >
								<img loading="lazy" v-else src="../../assets/list/document_delivery_guide_img7_2x.png" alt=""  class="img-responsive" >
							</div>
							<p class="mb20">
								2.한국세관 도착 후 통관검사를 합니다.
							</p>
							<div class="img-box">
								<img loading="lazy" v-if="!isMobile" src="../../assets/list/document_start_img10_2x.png" alt="" class="img-responsive" >
								<img loading="lazy" v-else src="../../assets/list/document_start_img10_2x.png" alt=""  class="img-responsive" >
							</div>
						</div>			
					</div>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8">
					<div class="type-card">
						<div class="card-head">
							4. 국내택배배송
							<img loading="lazy" src="../../assets/icon/ico_delivery.png" alt="" class="">
						</div>
						<div class="card-body">
							<p class="mb20">
								1.통관 완료 후 국내 택배사로 인계됩니다.
							</p>
							<div class="img-box">
								<img loading="lazy" v-if="!isMobile" src="../../assets/list/document_delivery_guide_img9_2x.png" alt="" class="img-responsive" >
								<img loading="lazy" v-else src="../../assets/list/document_delivery_guide_img9_2x.png" alt=""  class="img-responsive" >
							</div>
							<p class="mb20">
								2.국내택배배송이 시작됩니다.
							</p>
							<div class="img-box">
								<img loading="lazy" v-if="!isMobile" src="../../assets/list/document_delivery_guide_img10_2x.png" alt="" class="img-responsive" >
								<img loading="lazy" v-else src="../../assets/list/document_delivery_guide_img10_2x.png" alt=""  class="img-responsive" >
							</div>
						</div>			
					</div>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8">
					<div class="type-card">
						<div class="card-head">
							5. 상품 수령
							<img loading="lazy" src="../../assets/icon/flag_ko.png" alt="" class="">
						</div>
						<div class="card-body">
							<p class="mb20">
								1.직구 배송이 완료되어 상품을 수령합니다
							</p>
							<div class="img-box">
								<img loading="lazy" v-if="!isMobile" src="../../assets/list/document_delivery_guide_img11_2x.png" alt="" class="img-responsive" >
								<img loading="lazy" v-else src="../../assets/list/document_delivery_guide_img11_2x.png" alt=""  class="img-responsive" >
							</div>
							<p class="mb20">
								
							</p>
							<!-- <div class="img-box">
								<img loading="lazy" v-if="!isMobile" src="../../assets/list/document_delivery_guide_img12.png" alt="" class="img-responsive" >
								<img loading="lazy" v-else src="../../assets/list/document_delivery_guide_img12_2x.png" alt=""  class="img-responsive" >
							</div> -->
						</div>			
					</div>
				</el-col>
			</el-row>
			<div style="text-align: center;padding: 20px 0;font-size:24px;">마이페이지에서 진행상태를 확인하세요.</div>
		>
			<div class="caution" >
				<h2>이런 점은 주의해주세요.</h2>
			</div>
			
			<div class="list">
				<div class="list-child">
					<el-row >
						<el-col :xs="24" :sm="12">
							<div class="img-box"><img src="../../assets/list/document_delivery_guide_caution_img1.png" class="img-responsive img-radius" alt=""></div>
						</el-col>
						<el-col :xs="24" :sm="12">
							<div class="text-area">
								<div class="title">
									<span class="num">01</span>
									<div class="text">상품구입 후 배송신청서는 즉시 작성해주세요.</div>
								</div>
								<div class="content">
									배송신청서 작성이 늦어지면 구입하신 상품이 고로켓고에
									도착 후 주인을 못 찾아서 노데이터 구역으로 이동되어
									보관되며, 기간에 따라서 규정된 보관료 청구 및 보관기간
									종료 후 폐기 될 수 있어요.
								</div>
							</div>
						</el-col>
					</el-row>
				</div>
				<div class="list-child">
					<el-row >
						<el-col :xs="24" :sm="12">
							<div class="text-area">
								<div class="title">
									<span class="num">02</span>
									<div class="text">파손우려가 있는 상품은 포장보완을 권장해요</div>
								</div>
								<div class="content">
									중국 내 배송 > 국제운송 > 통관 > 국내택배사 운송 등 많은 과정을 거쳐서 이동하기에 파손 우려가 있는 상품은 포장보완을 꼭 권장해요.
								</div>
							</div>
						</el-col>
						<el-col :xs="24" :sm="12">
							<div class="img-box"><img src="../../assets/list/document_delivery_guide_caution_img2.png" class="img-responsive img-radius" alt=""></div>
						</el-col>
					</el-row>
				</div>
				<div class="list-child">
					<el-row >
						<el-col :xs="24" :sm="12">
							<div class="img-box"><img src="../../assets/list/document_delivery_guide_caution_img3.png" class="img-responsive img-radius" alt=""></div>
						</el-col>
						<el-col :xs="24" :sm="12">
							<div class="text-area">
								<div class="title">
									<span class="num">03</span>
									<div class="text">관련 법 준수하기</div>
								</div>
								<div class="content">
									관련 해당 국가의 법을 위반하는 상품들을 구매 / 배송 / 수령하지 않도록 해외 구매 / 배송 관련 법을 준수해야 해요. 리고 선적 금지 품목들도 주의하셔야 해요. 해당국 관련법과 규정 위반으로 발생되는 책임은 신청자에게 있습니다.
								</div>
							</div>
						</el-col>
					</el-row>
				</div>
				
			</div>
		</div>
		<div style="text-align: center;" >
			<router-link to="/agencyShipping" class="register-button">
				배송대행 신청
			</router-link>
		</div>
		
	</div>
</template>

<script>
	import PersonalBanner from '../../components/PersonalBanner.vue'
	import { safePush } from '@/utils/router';
	export default {
		components: {
			PersonalBanner
		},
		data() {
			return{
				
			}
		},
		computed: {
			isMobile() {
			  return window.innerWidth <= 768;
			},
		
		},	
		methods: {
			onCurrentNav(url){
				//this.$router.push(url);
				safePush(this.$router, url);
			},
			goCustomsinfoUrl(url){
				window.open(url, '_blank');
			},
		}
	
		
		
	}
</script>

<style scoped>
	.title-wrap{
		text-align: center;
		color: var(--frontground-color);
		margin-bottom: 60px;
	}
	.title-wrap h3 {
	    font-size: 20px;
	    font-weight: bold;
	    color: var(--frontground-color);
	    margin: 0 0 19px;
	}
	.title-wrap h4 {
	    font-weight: 700;
	    font-size: 36px;
	    line-height: 1.34;
	    margin: 0;
	}
	.title-wrap .summary{
		padding-top: 10px;
	}
	.type-card{
		border: 1px solid var(--border-color);
		box-shadow: 8px 12px 12px rgba(0, 0, 0, 0.06);
		border-radius: 26px;
		overflow: hidden;
		margin:5px 10px 20px 10px;
	}
	.type-card .card-head{
		font-weight: 700;
		font-size: 20px;
		height: 66px;
		line-height: normal;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #fff;
		gap: 0 8px;
		background: #000;	
	}
	.type-card .card-body{
		padding: 10px 20px;
		background: #fff;
		height:600px; 
	}
	
	.type-card .card-body p{
		font-size: 14px;
		color: #111111;
		line-height: 1.8;
	}
	.type-card .divided-line {
	    border-top: 1px dashed var(--border-color);
	    margin: 26px 0;
	}
	.mb20 {
	    margin: 20px 0 10px;
	}
	.img-box{
		display: flex;
		justify-content: center;
	}
	.img-responsive{
		display: block;
		max-width: 100%;
		height: auto;
	}
	.img-radius{
		border-radius: 24px;
	}
	
	.btn-wrap{
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.link-btn{
		display: inline-flex;
		justify-content: center;
		align-items: center;
		border-radius: 30px;
		font-weight: 600;
		font-size: 18px;
		text-transform: uppercase;
		text-decoration: none !important;
		border: 1px solid var(--main-color);
		padding: 13px 28px;
		transition: 0.25s;
		line-height: normal;
		cursor: pointer
	}
	.link-btn.type-2{
		color: var(--main-color);
		background: #fff;
	}
	.caution{
		margin-top: 100px;
		margin-bottom: 60px;
	}
	.caution h2{
		margin-top: 0;
		font-weight: 700;
		font-size: 24px;
		line-height: 29px;
		color: #111111;
		text-align: center;
	}
	

	.list-child{
		margin: 0 auto 20px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 0 50px;
		background: #71777D;
		border-radius: 20px;
		padding: 50px 200px;
	}
	.text-area{
		flex: 1;
	}
	.text-area .title{
		margin-top: 25px;
		display: flex;
		align-items: flex-start;
		gap: 0 6px;
		margin-bottom: 15px;
	}
	.text-area .title .num{
		text-align: center;
		width: 30px;
		line-height: 30px;
		background: #FFFFFF;
		border-radius: 15px;
		font-weight: 700;
		font-size: 14px;
		color: var(--main-color);
	}
	.text-area .title .text{
		margin-top: 5px;
		font-weight: 600;
		font-size: 17px;
		line-height: 20px;
		color: #FFFFFF;
	}
	.text-area .content{
		font-size: 17px;
		line-height: 1.6;
		color: #FFFFFF;
		word-break: keep-all;
	}
	.register-button{
		margin-top: 10px;
		display: inline-flex;
		justify-content: center;
		align-items: center;
		gap: 10px;
		min-width: 180px;
		margin-bottom: 40px;
		height: 64px;
		border: 1px solid var(--main-color);
		background: var(--main-color);
		border-radius: 36px;
		font-weight: 500;
		font-size: 17px;
		text-decoration: none !important;
		color: #fff !important;
		transition: 0.25s;
		cursor: pointer;
	}
	
	.visible-xs {
	    display: none !important;
	}
	
	
	@media (min-width: 992px) {
		.content-zsy{
			width: 1270px;
			margin: 2.5rem auto;
		}
	}
	@media (max-width: 768px) {
		
		.title-wrap{
			margin-top: 20px;
		}
		.title-wrap h3 {
			font-size: 18px;
			color: #0055D4;
			font-weight: bold;
			line-height: 23px;
		}
		.title-wrap h4 {
			font-weight: 700;
			font-size: 30px;
			line-height: 39px;
			text-align: center;
		}
		.list{
			margin:16px;
		}
		.list-child{
			margin: 0 auto 20px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			gap: 0 50px;
			background: #71777D;
			border-radius: 20px;
			padding: 20px;
		}
		
		.visible-xs {
		    display:block !important;
		}
		.hidden-xs {
			display: none !important;
		}
	}
</style>